import TranslationEN from "./en/common.json"
import TranslationRU from "./ru/common.json"

const resources = {
  ru: { common: TranslationRU },
  en: { common: TranslationEN },
}

export default resources
